<template>
  <div class="login-page">
    <div class="login-page-brand">
      <img :src="logoUrl" class="login-page-brand__logo" alt="白医云">
    </div>
    <div class="login-card">
      <div class="login-card-header">
        <img :src="logoUrl" class="logo-img" alt="白医云">
        <h2 class="form-title">白医云·医中心端</h2>
<!--        <p class="form-subtitle">智慧医疗 · 医生工作台登录</p>-->
      </div>

      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            type="text"
            auto-complete="off"
            placeholder="请输入手机号"
            prefix-icon="el-icon-mobile-phone"
            size="medium">
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            auto-complete="off"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="medium"
            show-password
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>

        <div class="form-options">
          <el-checkbox v-model="loginForm.rememberMe" checked>记住我</el-checkbox>
        </div>

        <el-form-item class="login-btn-item">
          <el-button
            :disabled="loading"
            size="medium"
            type="primary"
            class="login-btn"
            :class="{ 'login-btn--loading': loading }"
            @click.native.prevent="handleLogin">
            登 录
          </el-button>
        </el-form-item>
      </el-form>

      <transition name="login-loading-fade">
        <div v-if="loading" class="login-loading-mask">
          <div class="login-loading-panel">
            <div class="login-loading-spinner">
              <span class="login-loading-spinner__ring"></span>
              <span class="login-loading-spinner__core"></span>
            </div>
            <p class="login-loading-title">正在登录</p>
            <p class="login-loading-desc">请稍候，正在验证您的账号信息...</p>
          </div>
        </div>
      </transition>

      <div class="el-login-footer">
        <div class="footer-links">
          <span>帮助</span>
          <span>隐私</span>
          <span>条款</span>
        </div>
        <div class="footer-copy">Copyright©2022 白医医疗技术部出品</div>
        <div class="footer-icp">
          <b @click="goBeiAn">吉ICP备2022009009号-3</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cookies from "js-cookie";
  import {encrypt, decrypt} from '@/utils/jsencrypt'
  import {login,getVersion,getXpVersion} from '@/api/login'
  import {loginTim,getTim} from '@/utils/tim-chat-adapter.js';
  import {isWebSocketChat} from '@/utils/chat-config.js';
  import logoUrl from '@/assets/logo/byyl-logo1.png'

  export default {
    name: "Login",
    data() {
      return {
        logoUrl,
        offsetVale: 1,
        agree: '',
        codeUrl: "",
        cookiePassword: "",
        loginForm: {
          // username: "18704393553",
          // password: "123456",
          username: "",
          password: "",
          rememberMe: true,
          agree: false,
          uuid: ""
        },
        loginRules: {
          username: [
            {required: true, trigger: "blur", message: "用户名不能为空"}
          ],
          password: [
            {required: true, trigger: "blur", message: "密码不能为空"}
          ],
          code: [{required: true, trigger: "change", message: "验证码不能为空"}]
        },
        loading: false,
        redirect: undefined
      };
    },
    watch: {
      $route: {
        handler: function (route) {
          this.redirect = route.query && route.query.redirect;
        },
        immediate: true
      }
    },
    created() {
      this.getBrowseVersion();
      this.getCookie();
    },
    methods: {
      goBeiAn(){
        window.open('http://beian.miit.gov.cn')
      },
      goGaBeiAn(){

      },
      async getServerVersion(AnalyzePath){
        // 获得软件系统版本号
        let response ;
        await getVersion().then(resp=>{
          console.log(resp,"version");
          response = resp;
        });
        // 开始验证是否更新
        if(response.code==0){
          let result = response.data;
          if(result.versionCode>AnalyzePath){
            console.log("..........需要更新............."+result.path);
            this.BeginUpdate(result.versionCode,result.path).then(function (result2) {
              let state=result2.substr(0,1);            //状态，0-错误，1-正雀，2-系统安装错误
              let AnalyzePath=result2.substr(2);        //错误
              console.log(state,"更新状态");
            });
          }
        }
      },
      async getXPServerVersion(AnalyzePath){
        // 获得软件系统版本号
        let response ;
        await getXpVersion().then(resp=>{
          console.log(resp,"version");
          response = resp;
        });
        // 开始验证是否更新
        if(response.code==0){
          let result = response.data;
          if(result.versionCode>AnalyzePath){
            console.log("..........XP浏览器需要更新............."+result.path);
            /*this.BeginUpdate(result.versionCode,result.path).then(function (result2) {
              let state=result2.substr(0,1);            //状态，0-错误，1-正雀，2-系统安装错误
              let AnalyzePath=result2.substr(2);        //错误
              console.log(state,"更新状态");
            });*/
          }
        }
      },
      getOsVersionMethodCheck(){
        try{
          if(window.getOsVersion && typeof(getOsVersion) == "function"){
            console.log("getOsVersion存在这个方法")
            return true;
          }else{
            console.log("getOsVersion不存在这个方法")
            return false;
          }
        }catch(e){
          console.log("方法不存在");
          return false;
        }
      },
      async getBrowseVersion(){
        // 是否存在查看操作系统的方法
        let checkOsVersionMethod = this.getOsVersionMethodCheck();
        console.log("checkOsVersionMethod->",checkOsVersionMethod)
        let that = this
        if(checkOsVersionMethod){
          // 存在这个方法
          let osVersion = await this.myBrowser.getOsVersion(osVersion=> {    //取得浏览器版本号
            return osVersion;
          });
          console.log("操作系统版本-》osVersion->",osVersion)
          // 获得浏览器版本
          window.getVersion(function (result) {    //取得浏览器版本号
            let state=result.substr(0,1);            //状态，0-错误，1-正雀，2-系统安装错误
            let AnalyzePath=result.substr(2);        //版本号
            console.log("浏览器更新---->返回值【0-参数错误；1-正确，版本号，2-系统安装错误】当前返回值="+result);
            console.log("浏览器当前版本号：version=",AnalyzePath);
            if (osVersion == '1-WinXp' || osVersion == '1-WinVista') {
              console.log("winXp更新检测");
              that.getXPServerVersion(AnalyzePath)
            }else{
              console.log("<===================win7及其以上版本自动更新=====================>")
              console.log(AnalyzePath,"浏览器当前版本号：version");
              that.getServerVersion(AnalyzePath)
            }
          });
        }else{
          // 更新到win7版本
          // 获得浏览器版本
          window.getVersion(function (result) {    //取得浏览器版本号
            let state=result.substr(0,1);            //状态，0-错误，1-正雀，2-系统安装错误
            let AnalyzePath=result.substr(2);        //版本号
            console.log("---老版本浏览器更新----");
            console.log("浏览器当前版本号：version=",AnalyzePath);
            console.log("<===================win7及其以上版本自动更新=====================>")
            console.log(AnalyzePath,"浏览器当前版本号：version");
            that.getServerVersion(AnalyzePath)
          });
        }
      },
      clickNavigation() {
        this.msgError("请先进行登录后才能操作功能！！！");
      },
      clickItem(e) {
        e === this.agree ? this.agree = '' : this.agree = e
      },
      getCookie() {
        const username = Cookies.get("username-center");
        //const password = Cookies.get("password-center");
        const rememberMe = Cookies.get('rememberMe-center')
        this.loginForm = {
          username: username === undefined ? this.loginForm.username : username,
          // password: password === undefined ? this.loginForm.password : decrypt(password),
          rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
        };
      },
      handleLogin() {
        let that = this;
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            Cookies.set("username-center", this.loginForm.username, {expires: 60 * 24 * 10 * 365});
            this.loading = true;
            login(this.loginForm.username, this.loginForm.password).then(response => {
              console.log('-------------登录返回对象--------');
              console.log("response",response);
              this.loading = false;
              if(response.code==0){
                this.loading = false;
                // 记住我 验证
                if (this.loginForm.rememberMe) {
                  Cookies.set("username-center", this.loginForm.username, {expires: 60 * 24 * 10 * 365});
                  //Cookies.set("password-center", encrypt(this.loginForm.password), {expires: 60*24*10*365});
                  Cookies.set('rememberMe-center', this.loginForm.rememberMe, {expires: 60 * 24 * 10 * 365});
                } else {
                  //Cookies.remove("password-center");
                  Cookies.remove("username-center");
                  Cookies.remove('rememberMe-center');
                }
                //auditStatus 审核状态 0 待审核 1 成功 2驳回   quickRole角色
                let resUser = response.data;
                // this.setToken(resUser.token,{expires: 60*24*10*365});
                this.setToken(resUser.token);
                let {token,refreshToken,expireTtl,userId,userSign,userName} = resUser;
                let refreshTokenObject = {token,refreshToken,expireTtl}
                console.log("refreshTokenObject---->",resUser);
                this.setJsonObjectToLocal(window.sessionStorage,this.$CONSTANT.REFRESH_TOKEN,refreshTokenObject);
                localStorage.setItem("public-doctor-userId",userId);
                localStorage.setItem("public-doctor-tim-sign",userSign);
                localStorage.setItem("userName",userName);  //sessionStorage
                localStorage.setItem("loginType",response.data.type);
                localStorage.setItem("topOrgId",response.data.type);  //sessionStorage
                localStorage.setItem("commonOrgId",response.data.topOrgId);  //sessionStorage
                // 存储手机号 验签使用
                localStorage.setItem("phone",this.loginForm.username);
                // 存储是否允许收取定金的标识
                localStorage.setItem("hasDeposit", response.data.hasDeposit || '0');
                if(userId && userSign && !isWebSocketChat()){
                  loginTim();
                }
                location.href="/";
              }else{
                this.msgError(response.msg);
              }
            }).catch(() => {
              this.loading = false;
            });
          }
        });
      }
    }
  };
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #f2f3f5;
  background-image: url('~@/assets/logo-bag.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-page-brand {
  position: absolute;
  top: 28px;
  left: 36px;
  z-index: 2;
}

.login-page-brand__logo {
  display: block;
  width: 350px;
  max-width: 42vw;
  height: auto;
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e6eb;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  padding: 40px 40px 32px;
}

.login-card-header {
  text-align: center;
  margin-bottom: 32px;
}

.logo-img {
  width: 140px;
  margin-bottom: 16px;
}

.form-title {
  font-size: 20px;
  font-weight: 600;
  color: #1d2129;
  margin: 0 0 6px;
}

.form-subtitle {
  font-size: 13px;
  color: #86909c;
  margin: 0;
}

.login-form {
  width: 100%;
}

.login-form >>> .el-form-item {
  margin-bottom: 20px;
}

.login-form >>> .el-input__inner {
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  background: #f7f8fa;
  border-color: #e5e6eb;
}

.login-form >>> .el-input__inner:focus {
  background: #fff;
}

.form-options {
  margin-bottom: 4px;
}

.login-form >>> .el-checkbox__label {
  font-size: 13px;
  color: #4e5969;
}

.login-btn-item {
  margin-bottom: 0 !important;
  margin-top: 8px;
}

.login-btn {
  width: 100%;
  height: 42px;
  font-size: 15px;
  letter-spacing: 2px;
  border-radius: 8px;
  transition: opacity 0.2s ease;
}

.login-btn--loading {
  opacity: 0.72;
}

.login-loading-fade-enter-active,
.login-loading-fade-leave-active {
  transition: opacity 0.25s ease;
}

.login-loading-fade-enter,
.login-loading-fade-leave-to {
  opacity: 0;
}

.login-loading-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(242, 243, 245, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.login-loading-panel {
  min-width: 280px;
  padding: 36px 40px 32px;
  text-align: center;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e5e6eb;
  box-shadow: 0 12px 40px rgba(22, 119, 255, 0.12), 0 4px 16px rgba(0, 0, 0, 0.06);
}

.login-loading-spinner {
  position: relative;
  width: 56px;
  height: 56px;
  margin: 0 auto 20px;
}

.login-loading-spinner__ring {
  position: absolute;
  inset: 0;
  border: 3px solid #e8f3ff;
  border-top-color: #1677ff;
  border-radius: 50%;
  animation: login-spin 0.85s linear infinite;
}

.login-loading-spinner__core {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  margin: -5px 0 0 -5px;
  background: #1677ff;
  border-radius: 50%;
  box-shadow: 0 0 0 6px rgba(22, 119, 255, 0.12);
  animation: login-pulse 1.2s ease-in-out infinite;
}

.login-loading-title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
  letter-spacing: 1px;
}

.login-loading-desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #86909c;
}

@keyframes login-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes login-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.88);
    opacity: 0.75;
  }
}

.el-login-footer {
  margin-top: 32px;
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #f2f3f5;
}

.footer-links {
  margin-bottom: 10px;
}

.footer-links span {
  font-size: 12px;
  color: #86909c;
  margin: 0 10px;
  cursor: pointer;
  transition: color 0.2s;
}

.footer-links span:hover {
  color: #1677ff;
}

.footer-copy {
  font-size: 12px;
  color: #c9cdd4;
  margin-bottom: 6px;
}

.footer-icp b {
  font-size: 12px;
  color: #86909c;
  cursor: pointer;
  font-weight: normal;
}

.footer-icp b:hover {
  color: #1677ff;
}
</style>



// WEBPACK FOOTER //
// src/views/user/login.vue